import React, { useEffect } from 'react';
import { useState } from 'react';
import './App.scss';
import { Layout } from './Components/Layout/Layout';
import loadingImage from './assets/images/page_loading_svg.gif'

const App: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  // handle state for theme
  useEffect(() => {
    let htmlClasses = document.querySelector("html")?.classList;
    if (localStorage.theme === "dark") {
      htmlClasses!.add("dark");
    }
    setIsLoading(false)
  }, []);




  return (
    <div className="App">
      {isLoading
        ? <div className="w-full h-screen flex justify-center items-center bg-white dark:bg-cusBlack">
          <img src={loadingImage} alt="" className="stop_img_drag w-36" />
        </div>
        : <Layout />
      }
    </div>
  );
}

export default App;
